export default __webpack_public_path__ + "static/media/edit.cf4f139f.svg";